import { useIntl } from 'react-intl';
import styled from 'styled-components';

import { Tag } from '@sorare/core/src/atoms/ui/Tag';

type Props = React.ComponentProps<typeof Tag>;

export const InjuryStatusIcon = ({ small = true, ...rest }: Props) => {
  const { formatMessage } = useIntl();

  return (
    <Tag
      round
      small={small}
      color="yellow"
      aria-label={formatMessage({
        id: 'InjuryStatusIcon',
        defaultMessage: 'injured',
      })}
      {...rest}
    >
      !
    </Tag>
  );
};

export const BigInjuryStatusIcon = styled(InjuryStatusIcon).attrs({
  small: false,
})`
  font-size: var(--double-unit);
`;
